import { call } from "redux-saga/effects";
import { backOfficeApiService } from "../../../../actionService/apiService";
import { ApiCallResult } from "../../../../types";
import DealNotificationDto, { DealQuestionContextDto } from "../../../../../dto/Notification/DealNotificationDto";
import endpoints from "./dealQuestions.endpoints";
import PaymentDto from "../../../../../dto/Payment/PaymentDto";
import { SpecialInvoiceDto, SpecialPaymentDto } from "../../../../../dto/Deal/SpecialFinanceDto";
import {
  CreateDealQuestionRequestDto,
  GetDealQuestionContextRequestDto,
  GetMyDealQuestionsRequestDto,
  UpdateDealQuestionStatusRequestDto,
} from "./dealQuestions.requestsDto";

const backOfficeDealQuestionsApi = {
  cardPayments: function* ({ dealId }: GetDealQuestionContextRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endpoints.cardPayments(dealId))) as ApiCallResult<
      Array<PaymentDto>
    >;
  },
  specialFinance: function* ({ dealId }: GetDealQuestionContextRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endpoints.specialFinance(dealId))) as ApiCallResult<{
      invoices: Array<SpecialInvoiceDto>;
      payments: Array<SpecialPaymentDto>;
      bankNames: Record<number, string>;
    }>;
  },
  context: function* ({ dealId, officeType }: GetDealQuestionContextRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endpoints.context(dealId), undefined, {
      officeType,
    })) as ApiCallResult<DealQuestionContextDto>;
  },
  create: function* ({ dealId, officeType, ...question }: CreateDealQuestionRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Post], endpoints.create(dealId), question, undefined, {
      officeType,
    })) as ApiCallResult<DealNotificationDto>;
  },
  getAll: function* (query: GetMyDealQuestionsRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Get], endpoints.controller, undefined, query)) as ApiCallResult<
      Array<DealNotificationDto>
    >;
  },
  changeStatus: function* ({ id, officeType, ...update }: UpdateDealQuestionStatusRequestDto) {
    return (yield call([backOfficeApiService, backOfficeApiService.Put], endpoints.status(id), undefined, update, {
      officeType,
    })) as ApiCallResult<DealNotificationDto>;
  },
};

export default backOfficeDealQuestionsApi;
